/**
 * Silo Launchers API Module
 * 
 * Naming Convention (see phase2_1_refactor_instructions.md):
 * - launchersApi / siloLaunchersApi = Silo_Launcher_Record operations
 * - LauncherData = Silo_Launcher_Record data model
 * - ProfileData = Silo_Profile_Record data model
 */
export { launchersApi, siloLaunchersApi } from './api';
export { LauncherData, ProfileData, LAUNCHER_TYPE } from './types';

// Aliases for new naming convention
export { LauncherData as SiloLauncherData } from './types';
export { ProfileData as SiloProfileData } from './types';

